import { toast } from 'react-toastify'
import ClubService from 'Services/club'
import CustomLinkService from 'Services/customlinks'

const cloneClient = async cloneId => {
  if (!cloneId) return toast.error('No client was selected')

  const clonedClient = (await ClubService.get({ id: cloneId })).data

  const clonedName = (await ClubService.getUniqueName({ name: decodeURI(clonedClient.clubName) }))
    .name
  const clonedAppCode = ''

  const customLinks = await CustomLinkService.duplicate({ id: cloneId })

  return { club: { ...clonedClient, clubName: clonedName, clubId: clonedAppCode, customLinks } }
}

export default cloneClient
